import React from 'react';
import { Card, Empty, Table } from 'antd';

export default function OrderItemsCard(props) {
    const { order } = props;
    const items = Array.isArray(order.items) ? order.items : [];

    if (!items.length) {
        return <Card title="Sản phẩm"><Empty description="Chưa có sản phẩm" /></Card>;
    }

    return (
        <Card title="Sản phẩm">
            <Table
                rowKey={(record, index) => `${record.variant_id || index}`}
                pagination={false}
                dataSource={items}
                columns={[
                    { title: 'SKU', render: (_, item) => (item.variant_snapshot ? item.variant_snapshot.sku : '') },
                    { title: 'Tên', render: (_, item) => (item.variant_snapshot ? item.variant_snapshot.name : '') },
                    { title: 'SL', dataIndex: 'quantity' },
                    { title: 'Đơn giá', render: (_, item) => `${new Intl.NumberFormat('vi-VN').format(item.unit_price || 0)}đ` },
                    { title: 'Thành tiền', render: (_, item) => `${new Intl.NumberFormat('vi-VN').format(item.line_total || 0)}đ` }
                ]}
            />
        </Card>
    );
}
